import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import Loader from "../../../../components/Common/loader";
import TableFilterDynamique from "components/Common/TableFilter/TableFilterDynamique";
import useTeacher from "../hooks/useTeacher";
import { FilterField } from "components/Common/TableFilter/TableFilter";
import TaskList from "feature-module/academic/class-task/components/TaskList";
import { useParams } from "react-router-dom";

const TeacherTasks: React.FC = () => {
    const [filters, setFilters] = useState<{ [key: string]: string | number | null }>({});
    const { t } = useTranslation();
    const { id } = useParams<{ id: string }>();
    const { tasks, loading, fetchTasksTeacher } = useTeacher();
    useEffect(() => {
        if (id) {
            fetchTasksTeacher(id);
        }
    }, []);

    const filterFields: FilterField[] = [
        { key: "title", label: t("task_title"), type: "text" },
        { key: "subject", label: t("subject"), type: "text" },
        { key: "dueDate", label: t("due_date"), type: "date" },
    ];

    const handleApplyFilters = (newFilters: { [key: string]: string | number | null }) => {
        setFilters(newFilters);
    };

    const handleResetFilters = () => {
        setFilters({});
    };

    const filteredTasks = tasks?.filter((task: any) =>
        Object.entries(filters).every(([key, value]) => {
            if (!value) return true;
            return String(task[key]).toLowerCase().includes(String(value).toLowerCase());
        })
    ) || [];

    if (loading) return <Loader />;

    return (
        <div className="p-2">
            <div className="d-flex mb-3 justify-content-end gap-2">
                <TableFilterDynamique
                    fields={filterFields} filters={filters} onApply={handleApplyFilters} onReset={handleResetFilters}
                />
            </div>
            <TaskList tasks={filteredTasks} />
        </div>
    );
};

export default TeacherTasks;
